import * as React from "react";
import { StyleClass } from "../../Shared/Styles/CSS";
import { SyncNotification } from "./Sync/SyncNotification";

export function HeaderCenter() {
    return (
        <span>
            <span className={GetContainerStyleClass()}>
                <SyncNotification />
            </span>
        </span>
    );
}

export enum EHeaderCenterItem {
    syncAlert,
    todaysTime,
    stopWatch,
}

function GetContainerStyleClass() {
    const styleClass = StyleClass(`HeaderCenterContainer`, {
        position: "absolute",
        marginLeft: "auto",
        marginRight: "auto",
        left: "0",
        right: "0",
        top: "14px",
        fontSize: "13px",
        zIndex: -88,
    });

    return styleClass;
}
